import { ROLE_HISTORY_LIST_ROUTE } from 'config/route-consts';
import React from 'react'
import { Redirect, Route, Switch } from "react-router-dom";
import RoleHistoryList from './RoleHistoryList/RoleHistoryList';

function RoleHistoryView() {
    return (
        <Switch>
            <Route
                key={ROLE_HISTORY_LIST_ROUTE}
                path={ROLE_HISTORY_LIST_ROUTE}
                render={(props: any) => {
                    return <RoleHistoryList {...props} />;
                }}
            />
            <Redirect to={ROLE_HISTORY_LIST_ROUTE} />
        </Switch>
    );
}

export default RoleHistoryView